import React from 'react';
import clsx from 'clsx';
import { IOfferCrit, ITableDemandItem } from '@models/winnerSelection/ITableDemand';
import { IMatrixParticipant } from '../WinnerSelection2.types';
import { ICriteriaGroup } from '../utils/matrixView';

interface IProps {
    groups: ICriteriaGroup[];
    participants: IMatrixParticipant[];
    participantIds: string[];
    busy: boolean;
    rowIdOf: (critId: string) => string;
    onCriterion: (
        item: ITableDemandItem,
        participant: IMatrixParticipant,
        value: IOfferCrit,
        trigger: HTMLElement,
    ) => void;
}

/** Нижняя секция: общие критерии из заявок участников в тех же столбцах, что и позиции. */
const CriteriaSection: React.FC<IProps> = ({ groups, participants, participantIds, busy, rowIdOf, onCriterion }) => {
    if (groups.length === 0) return null;
    const columns = participants.length + 1;
    return (
        <>
            <tr className="ws2-criteria__separator" aria-hidden="true">
                <td colSpan={columns} />
            </tr>
            <tr className="ws2-criteria__title">
                <th scope="row">
                    <div className="ws2-criteria__heading">Критерии оценки</div>
                    <div className="ws2-criteria__subtitle">Общие для всех позиций</div>
                </th>
                {participants.map((participant, i) => (
                    <td key={participant.key} headers={participantIds[i]}>
                        <div className="ws2-participant__name">{participant.name}</div>
                        <div className="ws2-criteria__subtitle">
                            {participant.number ? `Ответы из заявки № ${participant.number}` : 'Ответы из заявки'}
                        </div>
                    </td>
                ))}
            </tr>
            {groups.map((group) => (
                <React.Fragment key={group.category}>
                    <tr className="ws2-criteria__group">
                        <th scope="rowgroup" colSpan={columns}>
                            {group.category}
                        </th>
                    </tr>
                    {group.items.map((item) => {
                        const rowId = rowIdOf(item.critId);
                        return (
                            <tr className="ws2-criteria__row" key={item.critId}>
                                <th scope="row" id={rowId}>
                                    <span className="ws2-criteria__name">{item.critName}</span>
                                </th>
                                {participants.map((participant, i) => {
                                    const value = item.offers[participant.key];
                                    const answer = value?.answer || value?.description;
                                    return (
                                        <td key={participant.key} headers={`${rowId} ${participantIds[i]}`}>
                                            {value ? (
                                                <button
                                                    type="button"
                                                    className={clsx(
                                                        'ws2-criteria__answer',
                                                        !answer && 'ws2-criteria__answer--empty',
                                                    )}
                                                    aria-label={`${item.critName}: ${participant.name}`}
                                                    disabled={busy}
                                                    onClick={(event) =>
                                                        onCriterion(item, participant, value, event.currentTarget)
                                                    }
                                                >
                                                    {answer || 'Ответ не предоставлен'}
                                                    {value.description && value.answer && (
                                                        <span className="ws2-criteria__comment">
                                                            {value.description}
                                                        </span>
                                                    )}
                                                </button>
                                            ) : (
                                                <span className="ws2-criteria__answer ws2-criteria__answer--empty">
                                                    —
                                                </span>
                                            )}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </React.Fragment>
            ))}
        </>
    );
};

export default CriteriaSection;
